/**
 * @papan/keybook/client — Browser-side keybook API + hooks
 *
 * Post-SSE refactor: no browser crypto. Hooks just wrap REST calls;
 * encryption is server-side via the per-tenant master key.
 */
export { keybookApi, setKeybookContext, getKeybookContext } from './api.js'
export type { FeatureStatus, Permission } from './api.js'
export { useKeybook } from './hooks.js'
export type { UseKeybookResult } from './hooks.js'
